import React from "react"
import ActionButton from "./actionbutton.component"
import { FormattedMessage } from "react-intl"
import { ButtonProps } from "../types/button"
export const CancelButton = (props: ButtonProps) => {
    return (
        <span className={"pr-2 m-0"}>
            <ActionButton
                className={"btn btn-secondary" + (props.className ?? "")}
                onClick={props.onClickCallback}
                disabled={props.disabled ?? false}
            >
                <FormattedMessage
                    id="common.button.cancel"
                    defaultMessage="Cancel"
                />
            </ActionButton>
        </span>
    )
}


// WEBPACK FOOTER //
// ./src/common/button/CancelButton.tsx